import React from "react";

import { useLoggedUser } from "state/reactive-vars/logged-user-var";

interface ProofCenterHeaderProps {
	propertyName?: string;
	propertyAddress?: string | null;
	propertyPhotoLink?: string | null;
	headline?: string | null;
	isDraft?: boolean;
}

const ProofCenterHeader: React.FC<ProofCenterHeaderProps> = ({
	propertyName,
	propertyAddress,
	propertyPhotoLink,
	headline,
	isDraft
}) => {
	const { loggedUserValue } = useLoggedUser();

	return (
		<div className="proof-center-header">
			<div className="proof-center-header-bar-top">
				<div className="proof-center-header-left">
					<div className="proof-center-header-label">
						{loggedUserValue?.organization?.organizationImageURL ? (
							<img src={loggedUserValue?.organization?.organizationImageURL} className="proof-center-header-logo" />
						) : null}
						<span>PROOF CENTER</span>
					</div>
				</div>

				{isDraft && <div className="proof-center-header-draft-badge">Draft</div>}

				<div className="proof-center-header-right">
					<button type="button" className="highnote-button">
						<img src={`${process.env.PUBLIC_URL}/assets/images/icons/twinkle-star.svg`} alt="" />
						Ask a question
					</button>
				</div>
			</div>

			<div className="proof-center-header-property-info">
				{propertyPhotoLink ? (
					<img src={propertyPhotoLink} className="proof-center-header-property-photo" alt="" />
				) : (
					<img src={`${process.env.PUBLIC_URL}/assets/images/icons/proof-center-apt.svg`} alt="" />
				)}
				<div>
					<div className="proof-center-header-property-name">
						{propertyName || "Loading..."}
						{/* {propertyName || "Loading..."} | <FiStar className="proof-center-header-star-icon" fill="white" color="white" /> [Property Logo] */}
					</div>
					<div className="proof-center-header-property-address">{propertyAddress || ""}</div>
					{headline && <div className="proof-center-header-property-tagline">{headline}</div>}
					<div className="proof-center-header-property-actions">
						<button className="proof-center-header-property-section-button">Request detailed report</button>
						<button className="proof-center-header-property-section-button">Contact property team</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProofCenterHeader;
